import { Component, OnInit, Output, EventEmitter, Input, ElementRef, NgZone, ViewChild, AfterViewInit, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ISubscription } from 'rxjs/Subscription';

import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, SortDescriptor } from '@progress/kendo-data-query';
import { JobsiteEquipmentService } from '@fs/services/jobsite-equipment';
import { CommonMethods } from '@services/common.method';
import { ActionName } from '@shared/enums/action-name';
import { ToastrService } from 'ngx-toastr';
import { Constants } from '@shared/models/constants';
import { PermissionPipe } from '@shared/pipes/permission';
import { ActionItemsModel } from '@fs/models/action-menu.model';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { FsUtil } from '@fs/services/fs-utils';
import { Grid } from '@fs/enums/grid.enum';
declare var SimpleBar: any;

@Component({
  selector: 'jobsite-equipment-list',
  templateUrl: './equipment-list.component.html',
  styleUrls: ['./equipment-list.component.scss'],
  providers: [JobsiteEquipmentService]
})
export class EquipmentListComponent implements OnInit {

  //#region Input/Output
  @Input() tabCounter: number;
  @Input() customerId: string;
  @Input() fetchData: boolean = false;
  @Input() jobsiteEquipmentSubject: Subject<any>;
  @Input() jobsiteId: string;
  @Output() openConfirmation = new EventEmitter();
  @Output() openDuplicateEquipment = new EventEmitter();
  @Output() openEditEquipment = new EventEmitter();
  @Output() openEquipmentDetail = new EventEmitter();
  @Output() showEqHistory = new EventEmitter<any>();
  @ViewChild('grid') k_grid: ElementRef;
  @Input() set load(val) {
    if (val) {
      this.GetEquipments();
    }
  }
  //#endregion

  //#region Variable Declarations
  private defaultSort: Array<SortDescriptor> = [];
  private subscriptions: ISubscription[] = [];
  deleteEquipmentID: string = "";
  public actionName = ActionName;
  public equipGridDS: GridDataResult = { data: [], total: 0 };
  public state: DataSourceRequestState = {
    skip: 0,
    take: 25,
    sort: this.defaultSort
  };
  public pageSizes = { pageSizes: [25, 100, 300], refresh: true };
  public showEquipmentEdit: boolean = false;
  public showEquipmentHistory: boolean = false;
  @ViewChild("grid", {
    read: ViewContainerRef
  }) equipmentgrid: ViewContainerRef;
  public items: ActionItemsModel[] = [
    { text: Constants.GridActions.JobSiteEquipment.ViewDetails, disabled: !this.permissionPipe.transform(this.actionName.Customers) },
    { text: Constants.GridActions.JobSiteEquipment.ViewHistory, disabled: !this.permissionPipe.transform(this.actionName.Customers) },
    { text: Constants.GridActions.Edit, disabled: !this.permissionPipe.transform(this.actionName.EditCustomer) },
    { text: Constants.GridActions.Duplicate, disabled: !this.permissionPipe.transform(this.actionName.EditCustomer) },
    { text: Constants.GridActions.Delete, disabled: !this.permissionPipe.transform(this.actionName.EditCustomer) },

  ];
  //#endregion

  //#region Constructor
  constructor(private equipmentService: JobsiteEquipmentService,
    private _elementRef: ElementRef,
    private commonMethods: CommonMethods,
    private toastr: ToastrService,
    private zone: NgZone,
    private permissionPipe: PermissionPipe,
    private showspinner: SpinnerService,
    private changeDetector: ChangeDetectorRef) {
    FsUtil.configSort(this.defaultSort, Grid.JobSiteEquipment)
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
  }

  ngOnDestroy() {
    this.DestroySubscriptions();
  }
  //#endregion

  //#region Methods

  private DestroySubscriptions() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }
  public dataStateChange(state: DataStateChangeEvent): void {
    state.sort =
      state.sort != null
        ? state.sort[0].dir == undefined
          ? this.defaultSort
          : state.sort
        : null;
    this.state = state;
    this.GetEquipments()
  }

  public equipmentActionmenu(actionresultData: ActionItemsModel) {
    let action: string = actionresultData.text;
    let dataItem = actionresultData.data;
    if (action == Constants.GridActions.JobSiteEquipment.ViewDetails) {
      this.OpenEquipmentDetail(dataItem.ID)
    }
    else if (action == Constants.GridActions.JobSiteEquipment.ViewHistory) {
      this.OpenEquipmentHistory(dataItem)
    }
    else if (action == Constants.GridActions.Edit) {
      this.OpenEditEquipment(dataItem.ID)
    }
    else if (action == Constants.GridActions.Duplicate) {
      this.OpenDuplicateEquipment(dataItem.ID)
    }
    else if (action == Constants.GridActions.Delete) {
      this.confirmDelete(dataItem.ID)
    }
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.GetEquipments();
  }

  public deleteEquipment(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.showspinner.showloader(this.equipmentgrid, this.tabCounter, instantSpinnerTime);
    this.equipmentService.DeleteEquipment({ customerId: this.customerId, jobsiteId: this.jobsiteId, equipmentId: this.deleteEquipmentID }).subscribe(response => {
      let msg : string = response.IsActive == false ? Constants.CustomToastMessages().EquipmentInactive : Constants.CustomToastMessages().EquipmentDeleteSuccess;
      this.toastr.success(msg, "Success");
      this.RefreshGrid();
      this.showspinner.hideLoader(this.equipmentgrid, this.tabCounter); 
    }, error => {
      this.toastr.error(error.error.Message, "Error");
      this.showspinner.hideLoader(this.equipmentgrid, this.tabCounter);
    })
  }

  confirmDelete(id: string) {
    this.deleteEquipmentID = id;
    this.openConfirmation.emit();
  }

  GetEquipments(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.showspinner.showloader(this.equipmentgrid, this.tabCounter, instantSpinnerTime);
    this.equipmentService.GetEquipments({ customerId: this.customerId, jobsiteId: this.jobsiteId }, this.state).subscribe(response => {
      //let response = this.dummyDataService.dummyEquipments();
      if (response != null) {
        if (response.Count > 0) {
          this.equipmentService.fetchEquipments(response, this.state, this.state.sort)
            .subscribe(r => {
              this.equipGridDS = r;
            });
        }
        else {
          this.equipGridDS.data = [];
          this.equipGridDS.total = 0;
        }
        this.showspinner.hideLoader(this.equipmentgrid, this.tabCounter);
        this.changeDetector.detectChanges();
      }
    });
  }

  public OpenEquipmentDetail(val: string) {
    this.openEquipmentDetail.emit(val)
  }

  public OpenEditEquipment(val: string) {
    this.openEditEquipment.emit(val)
  }

  public OpenDuplicateEquipment(val: string) {
    this.openDuplicateEquipment.emit(val)
  }

  public RefreshGrid(event = null) {
    if (event != null)
      event.preventDefault();
    //this.checkLoadingStatus.emit({ loadingComplete: false });
    this.GetEquipments();
  }

  public ReIntializeScroll() {
    this.zone.runOutsideAngular(() => {
      this.k_grid = new SimpleBar(
        $(this._elementRef.nativeElement).find(".k-grid-aria-root")[0],
        { autoHide: false }
      );
    });
  }

  public OpenEquipmentHistory(item) {
    this.showEqHistory.emit({ equipmentData: item });
  }
  /**
   * To check last 2 items in grid
   * @param idx rowIndex
   */
  public ApplyActionMnuClass(idx) {
    if (this.equipGridDS.data.length > 2) {
      if (((this.equipGridDS.data.length - 1) == idx)) {
        return true;
      }
      else if ((this.equipGridDS.data.length <= 3) && (this.equipGridDS.data.length - 2) == idx) {
        return false;
      }
      else if ((this.equipGridDS.data.length > 3) && (this.equipGridDS.data.length - 2) == idx) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }


  }
  //#endregion
}
